import { useState } from 'react'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { Title } from '@winnin/winnin_ui.components.title'

import { T, useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import GraphSelector from './GraphSelector'
import SelectedGraph from './SelectedGraph'
import './index.scss'

dayjs.extend(duration)

const TOLGEE_PREFIX = 'VideoContent-LiveGraphs'

function LiveGraphs({ provider, live }) {
  const t = useTranslate()

  const graphOptions = [
    {
      label: t(TOLGEE_GLOBALS.viewers),
      key: 'concurrentViewers',
      value: 'concurrentViewers',
    },
    {
      label: t(TOLGEE_GLOBALS.likes),
      key: 'likes',
      value: 'likes',
    },
  ]

  const [selectedGraph, setSelectedGraph] = useState(graphOptions[0])

  if (!live) {
    return null
  }

  return (
    <div className="VideoContent-LiveGraphs">
      <Title tag="h3" className="title">
        <T keyName={`${TOLGEE_PREFIX}-graphsTitle`}>Metrics during streaming</T>
      </Title>

      <div className="graphs-container">
        <GraphSelector
          provider={provider}
          selectedGraph={selectedGraph}
          setSelectedGraph={setSelectedGraph}
          options={graphOptions}
        />
        <SelectedGraph live={live} selectedGraph={selectedGraph} />
      </div>
    </div>
  )
}

export default LiveGraphs
